<template>
  <!-- Figma "Scan Serial Number Modal": header band, dark camera area with a teal frame, Keep Editing.
       Same behaviour as before: the first scan fills the field and closes. -->
  <div class="p-[20px] font-roboto">
    <FxModalHeader title="Scan Serial Number" subtitle="Point the camera at the QR code on the data plate" @close="closeModal" />
    <div class="relative mt-[15px] rounded-[14px] overflow-hidden bg-[#20242C] min-h-[259px]">
      <video ref="video" class="video w-full" />
      <div class="pointer-events-none absolute inset-x-[24px] top-[24px] bottom-[52px] rounded-[6px] border-2 border-dashed border-[#17C3B2]">
        <div class="absolute left-0 right-0 top-1/2 h-[2px] bg-[#17C3B2]" />
      </div>
      <p class="pointer-events-none absolute left-0 right-0 bottom-[16px] m-0 text-center text-[13px] text-[#C9CDD4]">
        Align the QR code inside the frame
      </p>
    </div>
    <div class="flex justify-center mt-[20px]">
      <button type="button" class="inline-flex items-center justify-center min-h-[38px] px-[26px] rounded-[5px] border-1 border-[#F67280] bg-white text-[14px] font-medium text-[#F67280]"
        data-bs-dismiss="modal" @click="closeModal">
        Keep Editing
      </button>
    </div>
  </div>
</template>

<script>
import FxModalHeader from "./FxModalHeader.vue";
import { BrowserMultiFormatReader } from "@zxing/library";

export default {
  components: { FxModalHeader },
  props: ["showModal"],
  data() {
    return {
      codeReader: null,
    };
  },
  watch: {
    showModal(newValue) {
      console.log(newValue);
      if (newValue) {
        this.startScanner();
      } else {
        this.stopScanner();
      }
    },
  },
  mounted() {
    this.codeReader = new BrowserMultiFormatReader();
  },
  methods: {
    startScanner() {
      this.codeReader
        .decodeFromVideoDevice(null, this.$refs.video, (result, err) => {
          if (result) {
            console.log("Scanned result:", result.text);
            this.$emit("scan-result", result.text);
            this.closeModal();
          }
          if (err) {
            console.error(err);
          }
        })
        .catch((err) => console.error(err));
    },
    stopScanner() {
      if (this.codeReader) {
        this.codeReader.reset();
      }
    },
    closeModal() {
      this.stopScanner();
      this.$emit("close");
    },
  },
};
</script>

<style>
.video {
  width: 100%;
  max-width: 600px;
  /* border: 1px solid black; */
}
.barcodeHeader .btn-close {
  font-size: 12px;
  opacity: 1;
  padding: 0.3rem;
  border: 2px solid #000;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  filter: invert(1);
}
</style>
